module.exports = __webpack_public_path__ + "components/flag/static/square/pl-5dc55d426d5a000ef5e4731374ad5bea.svg";